import dayjs from 'dayjs';
import { DefaultWidgetDateFormat } from '../../../widgets/repository/inputs/date/IDateWidget';
import { Datatype } from '../../datatype/Datatype';
import { IReference } from '../IReference';

/**
 * Trasforma il valore di una reference nella stringa da visualizzare,
 * in base al tipo di dato. Al momento gestisce le date (gg/mm/aaaa);
 * gli altri tipi passano invariati.
 */
export function formatReferenceValue(
  reference: IReference,
  value: any,
): string {
  // `field` può mancare nelle reference legacy serializzate nei rich text
  if (reference.field?.type === Datatype.Date) {
    return formatDateReferenceValue(value);
  }

  return value;
}

/**
 * Le date viaggiano come stringhe ISO nello stato del form (vedi `stringDate`):
 * per la visualizzazione le portiamo in gg/mm/aaaa, mantenendo il valore
 * originale se non interpretabile come data.
 */
function formatDateReferenceValue(value: any): string {
  if (!value || typeof value !== 'string') return value;

  // Data "di calendario": per i datetime ISO prendo la sola parte data,
  // senza conversioni di fuso orario.
  const dateOnly = /^\d{4}-\d{2}-\d{2}T\d{2}/.test(value)
    ? value.slice(0, 10)
    : value;

  // Parsing con lista di formati (richiede `customParseFormat`, esteso da
  // `initDayjs` al bootstrap): `YYYY-MM-DD` per i valori ISO, `DD/MM/YYYY`
  // per idempotenza sui valori già formattati.
  const date = dayjs(dateOnly, ['YYYY-MM-DD', 'DD/MM/YYYY'], true);
  return date.isValid()
    ? date.format(DefaultWidgetDateFormat.datePickerFormat)
    : value;
}
